import script from "./SaquesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SaquesTab.vue?vue&type=script&setup=true&lang=js"

import "./SaquesTab.vue?vue&type=style&index=0&id=7d1b8aed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1b8aed"]])

export default __exports__